<template>
  <vs-tabs>
    <vs-tab label="학교 등록" @click="onClickTab(0)">
      <vx-card>
        <div class="flex items-center justify-between mb-5">
          <h1 style="font-weight: 700; font-size: 18px"></h1>
          <div class="flex justify-end">
            <vs-button v-if="canDeleteField && !!postId" class="ml-4" color="secondary" type="border" @click="onClickDelete">삭제</vs-button>
            <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
            <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
          </div>
        </div>

        <!-- 학교 정보 -->
        <div class="mb-5">
          <h5 class="mb-5"><i class="dot"></i> 학교 정보</h5>
          <div class="writeGridContainer">
            <div>
              <div>학교 구분</div>
              <CustomOptionSelector :options="strCatOption" v-model="form.cat" class="w-full" />
            </div>
            <div>
              <div>학교명(필수)</div>
              <ml-input v-model="form.field_name" />
            </div>
            <div>
              <div>학교장</div>
              <ml-input v-model="form.director_name" />
            </div>
            <div>
              <div>행정실장</div>
              <ml-input v-model="form.meta.행정실장" />
            </div>
            <div>
              <div>학교 담당자</div>
              <ml-input v-model="form.meta.학교담당자" />
            </div>
            <div>
              <div>연락처</div>
              <ml-input v-model="form.phone" placeholder="예) 055-123-4567" />
            </div>
            <div>
              <div>학교 주소</div>
              <ml-input v-model="form.address" />
            </div>
            <div>
              <div>설립일~폐교일</div>
              <date-selector-rang v-model="dateSelectorRang" @input="inputDateSelectorRang" />
            </div>
          </div>
        </div>

        <!-- 취약개소 현황(unit : ea) -->
        <div class="mb-5">
          <h5 class="mb-5"><i class="dot"></i> 취약개소 현황(unit : ea)</h5>
          <table>
            <thead>
              <th v-for="vulnerable in vulnerableList" :key="vulnerable">
                {{ vulnerable }}
              </th>
            </thead>
            <tbody>
              <tr>
                <td v-for="vulnerable in vulnerableList" :key="vulnerable">
                  <comma-input placeholder="입력" v-model="form.meta.vulnerable[vulnerable]" class="w-full" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 기관 정보 -->
        <company-add-module title="기관 정보" detailTitle="기관 세부 정보" labelComName="기관명" detailLabelComName="기관명" v-model="companyList" @remove="removeCompany" />

        <!-- 참여 인원 정보 -->
        <company-user-auth-module
          :colData="[
            { head: '기관명', key: 'company_id' },
            { head: '사용자명', key: 'name' },
            { head: '연락처', key: 'phone' },
          ]"
          :users="userList"
          v-model="joinUsers"
        />

        <div class="my-8" style="display: grid; grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
          <div>
            <p class="title-n">현장조감도</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_view" />
          </div>
          <div>
            <p class="title-n">현장약도</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_map" />
          </div>
          <div>
            <p class="title-n">현장사진</p>
            <file-uploader type="only-image" class="upload-img" v-model="form.field_photo" />
          </div>
        </div>

        <file-upload-module v-model="form.fileList" />
      </vx-card>
    </vs-tab>
    <vs-tab label="학교 현황" @click="onClickTab(1)"></vs-tab>
  </vs-tabs>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";

import FileUploadModule from "@/views/modules/FileUploadModule";
import FileUploader from "@/components/FileUploader";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import * as UiUtil from "@/util/UiUtil";
import { canDeleteField } from "@/util/FieldPermission";

export default {
  components: {
    DateSelector,
    DateSelectorRang,
    SearchNavStartEnd,
    CompanyUserAuthModule,
    CompanyAddModule,
    FileUploader,
    FileUploadModule,
    CustomOptionSelector,
  },
  data() {
    return {
      form: {
        field_name: "",
        director_name: "",
        safety_manager_name: "",

        start_work_at: "",
        be_completed_at: "",

        deposit_amount: "",
        address: "",

        facility_category_id: "",
        cat: "",

        company_ids: [], // 참여 업체 목록
        user_ids: [], // 참여 사용자 목록

        field_view: {}, // 현장 조감도
        field_map: {}, // 현장 약도
        field_photo: {}, // 현장 사진

        fileList: [],

        meta: {
          행정실장: "",
          학교담당자: "",
          vulnerable: {},
          companyTypes: [],
          director_name: "",
          cat3Name: "",
        },
      },
      companyList: [],
      userList: [],
      joinUsers: [],

      catOption: [],
      dateSelectorRang: { sDate: "", eDate: "" },
    };
  },
  computed: {
    postId() {
      return this.$route.params.postId;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    canDeleteField() {
      return canDeleteField(this.$store, this.projectId);
    },
    vulnerableList() {
      return ["사무실", "교실", "양호실", "과학실", "급식실", "음악실", "도서실", "휴게실", "경비실", "체육관", "창고", "화장실", "승강기", "에스컬레이터", "옹벽", "비탈사면", "공사현장", "기타"];
    },
    strCatOption() {
      return this.catOption.map((_op) => _op.value);
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  created() {
    this.initBreadcrumb();
    this.loadCat();
    if (this.postId) this.loadField();
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "학교 현황" }, { title: "학교", active: true }]);
    },
    async loadCat() {
      let url = "/api/v1/field/facility-category/cat3";
      const params = { tag: "school", cat1: "학교", cat2: "학교" };

      HttpRequest.get(url, { params }).then((response) => {
        const data = response.data.map((_cat) => {
          return { value: _cat.cat3, id: _cat.id };
        });
        this.catOption = data.sort((a, b) => a.id - b.id);
      });
    },
    async loadField() {
      const postId = this.postId;
      await this.$store.dispatch("project/LOAD_FIELD", { postId });
      const info = this.$store.state.project.fieldInfo;

      this.joinUsers = info.users;
      this.form = { ...info, meta: JSON.parse(info.meta) };

      if (this.form.field_map.length > 0) {
        this.form.field_map = this.form.field_map[0];
      } else {
        this.form.field_map = {};
      }
      if (this.form.field_photo.length > 0) {
        this.form.field_photo = this.form.field_photo[0];
      } else {
        this.form.field_photo = {};
      }
      if (this.form.field_view.length > 0) {
        this.form.field_view = this.form.field_view[0];
      } else {
        this.form.field_view = {};
      }

      if (!!info.facility_category_id) {
        this.form.cat = info.facility_category.cat3;
      }

      this.companyList = info.companies;
      this.dateSelectorRang = { sDate: info.start_work_at, eDate: info.be_completed_at };
    },
    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },
    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },
    inputDateSelectorRang(value) {
      this.form.start_work_at = value.sDate;
      this.form.be_completed_at = value.eDate;
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "field-school-list" });
      } else if (tabIndex === 1) {
        this.$router.push({ name: "field-school-info" });
      }
    },
    onClickSave() {
      if (!`${this.form.field_name || ""}`.trim()) {
        UiUtil.alertDialog("학교명을 입력해 주세요.");
        return;
      }
      const phone = `${this.form.phone || ""}`.trim();
      if (phone && !/^[0-9+()\-\s]+$/.test(phone)) {
        UiUtil.alertDialog("연락처는 숫자와 하이픈(-)만 입력할 수 있습니다.");
        return;
      }

      const isEmptyCatOption = this.catOption.length === 1 && this.catOption[0].value === "";
      if (!this.form.cat && !isEmptyCatOption) {
        UiUtil.alertDialog("분류를 선택해주세요.");
        return;
      }

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      this.form.company_ids = company_ids;
      this.form.user_ids = user_ids;
      this.form.project_id = this.$route.params.proj_id;

      const _optionId = this.catOption.find((_op) => _op.value === this.form.cat);
      this.form.facility_category_id = _optionId.id;

      let types = this.companyList.map((companyItem) => companyItem.com_type);
      this.form.meta.companyTypes = [...new Set(types)];

      this.form.meta.director_name = this.form.director_name;
      this.form.meta.cat3Name = this.form.cat;

      if (this.postId) {
        // update
        const fieldId = this.postId;
        this.$store
          .dispatch("project/UPDATE_FIELD", {
            field_code: "school",
            fieldId,
            ...this.form,
            meta: this.form.meta,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      } else {
        // create
        this.$store
          .dispatch("project/CREATE_FIELD", {
            field_code: "school",
            ...this.form,
            meta: this.form.meta,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      }
    },
    async onClickDelete() {
      if (!(await UiUtil.confirmDialog("삭제하시겠습니까?"))) return;
      const fieldId = this.postId;
      this.$store
        .dispatch("project/DELETE_FIELD", {
          fieldId,
        })
        .then((/*value*/) => {
          this.$router.back();
        });
    },
    onClickMoveList() {
      this.$router.push({ name: "field-school-list" });
    },
    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },
    workerYear() {},
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    text-align: center;

    background: #f9f9f9;
    padding: 15px 4px;
  }
  td {
    padding: 6px;
  }
}
</style>

<style scoped lang="scss">
.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
